import CookieConsentMessage from './CookieConsentMessage';

export default CookieConsentMessage;
